<template>
	<el-row :gutter="20" style="margin-left: 10px">
		<div class="text-left">
			<el-button type="primary" @click.prevent="createNew">{{ $t('kpi-config.add') }}</el-button>

			<el-button @click.prevent="remove">{{ $t('kpi-config.remove') }}</el-button>

			<el-button @click.prevent="test">{{ $t('kpi-config.test') }}</el-button>
		</div>
		<el-table
		    id="kpi-configuration"
		    :data="data"
		    style="width: 100%"
		    height="500"
		    :default-sort = "{prop: 'team', order: 'ascending'}"
		    @row-click="showDetail"
		    @selection-change="handleSelectionChange"
		    >
		    <el-table-column
		      type="selection"
		      width="55">
		    </el-table-column>
		    <el-table-column
		      prop="team"
		      :label="$t('kpi-config.team')"
		      width="150"
		      sortable
		      :filters="teamFilter"
              :filter-method="filterHandler">
		      <template slot-scope="scope">
		        {{ getTeam(scope.row.team) }}
		      </template>
		    </el-table-column>
		    <el-table-column
		      prop="practiceId"
		      :label="$t('kpi-config.practice')"
		      width="150"
		      sortable
		      :filters="practiceFilter"
              :filter-method="filterHandler">
		      <template slot-scope="scope">
		        {{ getPractice(scope.row.practiceId) }}
		      </template>
		    </el-table-column>
		    <el-table-column
		      prop="level"
		      :label="$t('kpi-config.level')"
		      width="200"
		      sortable>
		      <template slot-scope="scope">
		        {{ getLevel(scope.row.level) }}
		      </template>
		    </el-table-column>
		    <el-table-column
		      prop="item"
		      :label="$t('kpi-config.kpi')"
		      width="150"
		      sortable>
		      <template slot-scope="scope">
		        {{ getKPIItems(scope.row.item) }}
		      </template>
		    </el-table-column>
		    <el-table-column
		      prop="value"
		      :label="$t('kpi-config.request-value')"
		      width="150"
		      sortable>
		    </el-table-column>
		    <el-table-column
		      prop="startDate"
		      :label="$t('kpi-config.start-date')"
		      width="150"
		      sortable>
		    </el-table-column>
	    </el-table>
	    
		<el-dialog :title="$t('kpi-config.title')" 
			:visible.sync="showEdit"
			width="70%"
			top="30px"
			:append-to-body="true"
			:close-on-click-modal="false">
            <KPI :data="current" ref="kpiForm" @value-save="kpiCreated" />
            <div slot="footer" class="dialog-footer">
			    <el-button @click="showEdit = false">{{ $t('kpi-config.cancel') }}</el-button>
			    <el-button type="primary" @click="createKPI">{{ $t('kpi-config.save') }}</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="$t('kpi-config.title1')" 
			:visible.sync="showDetail"
			width="70%"
			top="30px"
			:append-to-body="true"
			:close-on-click-modal="false">
            <div>
            	<el-row v-for="d in testData">
				  <el-col :span="24">
				  <div class="grid-content">
				  	<el-descriptions :title="getTeam(d.team) + ' - ' + getPractice(d.practiceId) + ' - ' + getLevel(d.level)">
					    <el-descriptions-item  v-for="(k, index) in d.kpi" :label="getKPIItems(index)" v-if="k != 0 && k!= -1">{{ k }}</el-descriptions-item>
					</el-descriptions>
				  </div></el-col>
				</el-row>
            </div>
            <div slot="footer" class="dialog-footer">
			    <el-button @click="showDetail = false">{{ $t('kpi-config.cancel') }}</el-button>
			</div>
		</el-dialog>
	</el-row>
</template>
<style scoped>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>
<script>
// @ is an alias to /src
import moment from 'moment'
import KPI from '@/components/common/KPI.vue'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'

export default {
  name: 'KPI-Config-List',
  components: {
    KPI
  },
  data: function() {
    return {
	  data: null,
	  current: null,
	  showEdit: false,
	  selectedItems: [],
	  testData: [],
	  showDetail: false
	}
  },
  computed: {
    teamFilter: function() {
      let f = []
      for (let i = 0; i < this.team.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.team[i]['c_name'] : this.team[i]['e_name'],
        	value = this.team[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    },
    practiceFilter: function() {
      let f = []
      for (let i = 0; i < this.practice.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.practice[i]['c_name'] : this.practice[i]['e_name'],
        	value = this.practice[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    }
  },
  methods: {
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    createNew: function() {
      this.current = null
      this.showEdit = true
    },
    test: function() {
      let that = this,
          userId = localStorage.getItem('token')
      this.$http.get(this.API3_PREFIX + 'kpi_configuration_test?userId=' + userId).then(function (response) {
        //console.log(response.data)
		that.testData = response.data
		that.showDetail = true
      }).catch(function (error) {
		console.log(error)
      })
    },
    showDetail: function(row, column, event) {
      
    },
    handleSelectionChange: function(val) {
      this.selectedItems = val
    },
    kpiCreated: function(val) {
      console.log(val)
      this.showInvoiceForm = false
    },
    createKPI: function() {
      this.$refs.kpiForm.createKPI()
    },
    exportExcel () {
	  let wb = XLSX.utils.table_to_book(document.querySelector('#kpi-configuration'))
	  /* get binary string as output */
	  let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
	  try {
	    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'ER-KPI-Config.xlsx')
	  } catch (e) {
	    if (typeof console !== 'undefined')
	      console.log(e, wbout)
	  }
	  return wbout
    },
    
    loadData: function() {
      let that = this
      this.$http.get(this.API3_PREFIX + 'kpi_configuration').then(function (response) {
        //console.log(response.data)
		that.data = response.data
      }).catch(function (error) {
		console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  },
  mounted: function() {
    
  }
}
</script>